import React from 'react';
import PropTypes from 'prop-types';
import styles from './Title.module.sass';

function Title(props) {
  const { title, subtitle } = props;
  return (
    <div className={styles.head}>
      <div className={styles.background} />
      <div className={styles['text-wrapper']}>
        <h1 className={styles['title-text']}>
          { title }
        </h1>
        <div className={styles.subtitle}>
          { subtitle }
        </div>
      </div>
    </div>
  );
}

Title.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default Title;
